import React from 'react';
import PropTypes from 'prop-types';
import WarningAlert from '../alert/WarningAlert';
import { TITLE } from '../../constants/shared/CommonConstants';
import {
    DATE_RANGE_ALERT_TYPE,
    DATE_RANGE_STRICTLY_ENFORCED_ALERT_TYPE,
    INVALIDATE_ALERT_TYPE,
} from '../../constants/shared/WebEntryConstants';

const ConfirmationPopup = ({
    assessmentType,
    alertType,
    invalidateResult,
    setAlertType,
    datePickerRef,
    invalidateButtonRef,
    updateRowData,
    isPmPanelType,
}) => {
    const closeAlert = e => {
        e.focus();
        setAlertType(null);
    };

    const clearDate = () => {
        setAlertType(null);
        updateRowData({ date: null });
        datePickerRef.current.parentNode.focus();
    };

    const invalidateResultHandler = () => {
        setAlertType(null);
        updateRowData({
            correctResponses: null,
            incorrectResponses: null,
            date: null,
            formGrade: null,
            ...(isPmPanelType ? { formValues: {} } : {}),
        });
        invalidateResult();
    };
    switch (alertType) {
        case DATE_RANGE_ALERT_TYPE: {
            return (
                <WarningAlert
                    message={`This date is outside the selected ${TITLE.BENCHMARK_TITLE} window. Continue?`}
                    onApprove={() => closeAlert(datePickerRef.current.parentNode)}
                    onCancel={clearDate}
                />
            );
        }
        case DATE_RANGE_STRICTLY_ENFORCED_ALERT_TYPE: {
            return (
                <WarningAlert
                    message="Select a date within the current Benchmark window"
                    onApprove={clearDate}
                />
            );
        }
        case INVALIDATE_ALERT_TYPE: {
            return (
                <WarningAlert
                    message={
                        <>
                            This will delete the {assessmentType} assessment record.
                            <br />
                            <br /> Click <strong>OK</strong> to continue.
                        </>
                    }
                    onApprove={invalidateResultHandler}
                    onCancel={() => closeAlert(invalidateButtonRef.current)}
                />
            );
        }
        default:
            return null;
    }
};

ConfirmationPopup.defaultProps = {
    alertType: '',
    assessmentType: '',
    invalidateResult: () => {},
    setAlertType: () => {},
    datePickerRef: null,
    invalidateButtonRef: null,
    updateRowData: () => {},
    isPmPanelType: false,
};

ConfirmationPopup.propTypes = {
    alertType: PropTypes.string,
    assessmentType: PropTypes.string,
    invalidateResult: PropTypes.func,
    setAlertType: PropTypes.func,
    datePickerRef: PropTypes.object,
    invalidateButtonRef: PropTypes.object,
    updateRowData: PropTypes.func,
    isPmPanelType: PropTypes.bool,
};

export default ConfirmationPopup;
